// Suggestions only — UI shows these in the "Create Defaults" dialog so the
// recruiter can bulk-INSERT them. The text is what gets written to the DB
// verbatim (not an i18n key), so we ship one set per UI locale and pick by
// the active locale. After insertion the recruiter can rename/edit freely;
// these are never re-resolved to a translation.

export interface DefaultEmailTemplate {
  name: string;
  category: string;
  subject: string;
  body_html: string;
}

const WRAPPER_START =
  '<div style="font-family: Arial, Helvetica, sans-serif; max-width: 600px; margin: 0 auto; padding: 24px; color: #333;">';

const INFO_BOX =
  '<div style="background: #f8f9fa; border-left: 4px solid #4a90d9; padding: 16px; margin: 16px 0; border-radius: 4px;">';

const GREEN_BOX =
  '<div style="background: #f0f9f0; border-left: 4px solid #27ae60; padding: 16px; margin: 16px 0; border-radius: 4px;">';

function wrapVi(body: string): string {
  return `${WRAPPER_START}${body}<p style="margin-top: 24px; color: #666; font-size: 13px;">Trân trọng,<br><strong>Phòng Nhân sự</strong></p></div>`;
}

function wrapEn(body: string): string {
  return `${WRAPPER_START}${body}<p style="margin-top: 24px; color: #666; font-size: 13px;">Best regards,<br><strong>HR Department</strong></p></div>`;
}

const VI_TEMPLATES: DefaultEmailTemplate[] = [
  {
    name: 'Mời ứng tuyển',
    category: 'Tuyển dụng',
    subject: '[Tên công ty] Mời ứng tuyển cho vị trí {{job_title}}',
    body_html: wrapVi(
      '<p>Chào <strong>{{candidate_name}}</strong>,</p>' +
        '<p>Như đã trao đổi qua điện thoại, mình gửi JD để bạn xem xét ứng tuyển nha:</p>' +
        INFO_BOX +
        '<p style="margin: 0 0 8px;"><strong>Thông tin vị trí:</strong></p>' +
        '<ul style="margin: 0; padding-left: 20px;">' +
        '<li>Vị trí: <strong>{{job_title}}</strong></li>' +
        '<li>Mã công việc: <strong>{{job_code}}</strong></li>' +
        '</ul></div>' +
        '<p>[Giới thiệu ngắn về công ty: lĩnh vực, thị trường, địa điểm].</p>' +
        '<p>Nếu bạn thấy hứng thú với vị trí này, xin vui lòng phản hồi về email bên dưới để bên mình có thể sắp xếp phỏng vấn với Team Leader của công ty.</p>' +
        '<p>Mong sớm nhận được phản hồi của bạn.</p>',
    ),
  },
  {
    name: 'Reject sau vòng CV',
    category: 'Tuyển dụng',
    subject: '[Tên công ty]: Kết quả Vòng CV - Vị trí {{job_title}}',
    body_html: wrapVi(
      '<p>Chào bạn,</p>' +
        '<p>Cảm ơn bạn đã dành thời gian ứng tuyển vào vị trí <strong>{{job_title}}</strong> tại [Tên công ty]. Công ty đã thực sự bị ấn tượng bởi hồ sơ của bạn. Tuy nhiên, bạn chưa phù hợp với vị trí chúng mình đang tìm kiếm.</p>' +
        '<p>Để đưa ra được quyết định này, Công ty đã phải cân nhắc rất kỹ càng. Chúng mình rất vui vì có cơ hội tìm hiểu về kiến thức, kinh nghiệm cũng như kỹ năng của bạn. Công ty sẽ giữ lại hồ sơ của bạn và xin phép liên hệ lại với bạn khi có cơ hội phù hợp hơn trong tương lai.</p>' +
        '<p>Trân trọng cảm ơn bạn!</p>',
    ),
  },
  {
    name: 'Mời phỏng vấn offline',
    category: 'Tuyển dụng',
    subject: '[Tên công ty] Thư mời phỏng vấn vị trí {{job_title}}',
    body_html: wrapVi(
      '<p>Thân gửi <strong>{{candidate_name}}</strong>,</p>' +
        '<p>Cảm ơn bạn đã ứng tuyển vào vị trí <strong>{{job_title}}</strong> tại [Tên công ty].</p>' +
        '<p>Công ty trân trọng mời bạn tham dự buổi phỏng vấn tại công ty theo thông tin như sau:</p>' +
        INFO_BOX +
        '<ul style="margin: 0; padding-left: 20px;">' +
        '<li>Thời gian: <strong>{{interview_date}} - {{interview_time}}</strong></li>' +
        '<li>Địa chỉ: <strong>{{interview_address}}</strong></li>' +
        '</ul></div>' +
        '<p>Nếu có bất cứ câu hỏi nào, bạn đừng ngại liên hệ với bộ phận HR theo thông tin bên dưới.</p>' +
        '<p>Vui lòng xác nhận sự hiện diện của bạn khi nhận được email này.</p>',
    ),
  },
  {
    name: 'Mời phỏng vấn online',
    category: 'Tuyển dụng',
    subject: '[Tên công ty] Thư mời phỏng vấn vị trí {{job_title}}',
    body_html: wrapVi(
      '<p>Thân gửi <strong>{{candidate_name}}</strong>,</p>' +
        '<p>Cảm ơn bạn đã ứng tuyển vào vị trí <strong>{{job_title}}</strong> tại [Tên công ty].</p>' +
        '<p>Công ty trân trọng mời bạn tham dự buổi phỏng vấn theo thông tin như sau:</p>' +
        INFO_BOX +
        '<ul style="margin: 0; padding-left: 20px;">' +
        '<li>Thời gian: <strong>{{interview_date}} - {{interview_time}}</strong></li>' +
        '<li>Hình thức: Online qua Google Meet tại <a href="{{interview_link}}">Link</a></li>' +
        '</ul></div>' +
        '<p>Nếu có bất cứ câu hỏi nào, bạn đừng ngại liên hệ với bộ phận HR theo thông tin bên dưới.</p>' +
        '<p>Vui lòng xác nhận sự hiện diện của bạn khi nhận được email này.</p>',
    ),
  },
  {
    name: 'Reject sau phỏng vấn',
    category: 'Tuyển dụng',
    subject: '[Tên công ty]: Kết quả Phỏng vấn - Vị trí {{job_title}}',
    body_html: wrapVi(
      '<p>Chào <strong>{{candidate_name}}</strong>,</p>' +
        '<p>Cảm ơn bạn đã dành thời gian tham gia phỏng vấn vị trí <strong>{{job_title}}</strong> tại [Tên công ty]. Công ty đã thực sự bị ấn tượng bởi hồ sơ của bạn cũng như những gì bạn thể hiện trong suốt buổi phỏng vấn. Tuy nhiên, bạn chưa phù hợp với vị trí chúng mình đang tìm kiếm.</p>' +
        '<p>Để đưa ra được quyết định này, Công ty đã phải cân nhắc rất kỹ càng. Chúng mình rất vui vì có cơ hội gặp gỡ bạn và tìm hiểu về kiến thức, kinh nghiệm cũng như kỹ năng của bạn. Công ty sẽ giữ lại hồ sơ của bạn và xin phép liên hệ lại với bạn khi có cơ hội phù hợp hơn trong tương lai.</p>' +
        '<p>Trân trọng cảm ơn bạn!</p>',
    ),
  },
  {
    name: 'Mail offer',
    category: 'Tuyển dụng',
    subject: '[Tên công ty] Thư mời nhận việc {{candidate_name}} - Vị trí {{job_title}}',
    body_html: wrapVi(
      '<p>Thân gửi <strong>{{candidate_name}}</strong>,</p>' +
        '<p>Cảm ơn bạn đã tham gia buổi phỏng vấn với [Tên công ty] cho vị trí <strong>{{job_title}}</strong>.</p>' +
        '<p>Dựa trên nhu cầu phát triển nguồn nhân lực của công ty, [Tên công ty] gửi bạn offer với thông tin như sau:</p>' +
        GREEN_BOX +
        '<ul style="margin: 0; padding-left: 20px;">' +
        '<li>Chức danh: <strong>{{job_title}}</strong></li>' +
        '<li>Thời gian làm việc: [Giờ làm việc, ngày làm việc]</li>' +
        '<li>Địa điểm làm việc: [Địa chỉ văn phòng]</li>' +
        '<li>Mức lương chính thức: <strong>{{salary}}</strong></li>' +
        '<li>Mức lương Thử việc: [VD: 85% mức lương chính thức, thời gian thử việc]</li>' +
        '<li>Thời gian bắt đầu làm việc: <strong>{{start_date}}</strong> (dự kiến)</li>' +
        '</ul></div>' +
        '<p>Trên đây là Offer của [Tên công ty], mong bạn xem xét, cân nhắc kỹ càng và phản hồi lại thông tin qua email này để phòng Nhân sự có thể triển khai tiếp quy trình Tuyển dụng!</p>' +
        '<p>Rất hy vọng sẽ có cơ hội đồng hành cùng với bạn tại [Tên công ty]!</p>' +
        '<p><em>P/s: Khi trả lời email bạn vui lòng chọn REPLY ALL để tất cả mọi người đều nhận được thông tin!</em></p>',
    ),
  },
  {
    name: 'Onboarding - Chào mừng nhân viên mới',
    category: 'Quy trình nội bộ',
    subject: 'Welcome {{candidate_name}} to [Tên công ty]!',
    body_html: wrapVi(
      '<p>Hi,</p>' +
        '<p>Chào mừng bạn đã gia nhập đội ngũ nhân sự tại [Tên công ty] với vị trí <strong>{{job_title}}</strong>.</p>' +
        '<p>Mình là HR - Bộ phận Nhân sự sẽ đồng hành cùng bạn trong quá trình onboarding.</p>' +
        '<p>Dưới đây là checklist một số công việc bạn cần theo dõi và trao đổi trong ngày đầu đi làm (<strong>{{start_date}}</strong>):</p>' +
        '<ol>' +
        '<li>Ký hợp đồng thử việc &amp; Cam kết bảo mật: HR</li>' +
        '<li>Giới thiệu với mọi người trong công ty và người phụ trách: Bộ phận HR</li>' +
        '<li>Tạo và đăng nhập vào các tài khoản nội bộ: Email công ty, Portal, Slack/Skype...</li>' +
        '<li>Chốt lịch buổi đào tạo kiến thức Hội nhập với HR</li>' +
        '<li>Đọc quy chế công ty theo file đính kèm</li>' +
        '</ol>' +
        '<p>Nếu cần thêm thông tin gì, bạn cứ thoải mái liên hệ với mình nha.</p>' +
        '<p>Một lần nữa chúc mừng bạn và hy vọng bạn có nhiều trải nghiệm thú vị khi đồng hành cùng [Tên công ty] trong tương lai!</p>',
    ),
  },
];

const EN_TEMPLATES: DefaultEmailTemplate[] = [
  {
    name: 'Application invitation',
    category: 'Recruitment',
    subject: '[Company name] Invitation to apply for {{job_title}}',
    body_html: wrapEn(
      '<p>Hi <strong>{{candidate_name}}</strong>,</p>' +
        '<p>As discussed over the phone, I am sending you the JD for your consideration:</p>' +
        INFO_BOX +
        '<p style="margin: 0 0 8px;"><strong>Position details:</strong></p>' +
        '<ul style="margin: 0; padding-left: 20px;">' +
        '<li>Position: <strong>{{job_title}}</strong></li>' +
        '<li>Job code: <strong>{{job_code}}</strong></li>' +
        '</ul></div>' +
        '<p>[Short company introduction: industry, market, location].</p>' +
        '<p>If you are interested in this position, please reply to this email so we can schedule an interview with the Team Leader.</p>' +
        '<p>Looking forward to hearing from you soon.</p>',
    ),
  },
  {
    name: 'Reject after CV screening',
    category: 'Recruitment',
    subject: '[Company name]: CV review result - {{job_title}}',
    body_html: wrapEn(
      '<p>Hi,</p>' +
        '<p>Thank you for taking the time to apply for the <strong>{{job_title}}</strong> position at [Company name]. We were genuinely impressed by your profile. However, you are not the right fit for this particular role.</p>' +
        '<p>This decision was made after careful consideration. We are glad to have had the chance to learn about your knowledge, experience and skills. We will keep your profile on file and reach out should a more suitable opportunity arise in the future.</p>' +
        '<p>Thank you sincerely!</p>',
    ),
  },
  {
    name: 'Onsite interview invitation',
    category: 'Recruitment',
    subject: '[Company name] Interview invitation for {{job_title}}',
    body_html: wrapEn(
      '<p>Dear <strong>{{candidate_name}}</strong>,</p>' +
        '<p>Thank you for applying for the <strong>{{job_title}}</strong> position at [Company name].</p>' +
        '<p>We would like to invite you to an onsite interview with the following details:</p>' +
        INFO_BOX +
        '<ul style="margin: 0; padding-left: 20px;">' +
        '<li>Time: <strong>{{interview_date}} - {{interview_time}}</strong></li>' +
        '<li>Address: <strong>{{interview_address}}</strong></li>' +
        '</ul></div>' +
        '<p>If you have any questions, please feel free to contact HR using the information below.</p>' +
        '<p>Please confirm your attendance upon receiving this email.</p>',
    ),
  },
  {
    name: 'Online interview invitation',
    category: 'Recruitment',
    subject: '[Company name] Interview invitation for {{job_title}}',
    body_html: wrapEn(
      '<p>Dear <strong>{{candidate_name}}</strong>,</p>' +
        '<p>Thank you for applying for the <strong>{{job_title}}</strong> position at [Company name].</p>' +
        '<p>We would like to invite you to an interview with the following details:</p>' +
        INFO_BOX +
        '<ul style="margin: 0; padding-left: 20px;">' +
        '<li>Time: <strong>{{interview_date}} - {{interview_time}}</strong></li>' +
        '<li>Format: Online via Google Meet — <a href="{{interview_link}}">Link</a></li>' +
        '</ul></div>' +
        '<p>If you have any questions, please feel free to contact HR using the information below.</p>' +
        '<p>Please confirm your attendance upon receiving this email.</p>',
    ),
  },
  {
    name: 'Reject after interview',
    category: 'Recruitment',
    subject: '[Company name]: Interview result - {{job_title}}',
    body_html: wrapEn(
      '<p>Hi <strong>{{candidate_name}}</strong>,</p>' +
        '<p>Thank you for taking the time to interview for the <strong>{{job_title}}</strong> position at [Company name]. We were genuinely impressed by your profile and what you demonstrated during the interview. However, you are not the right fit for this particular role.</p>' +
        '<p>This decision was made after careful consideration. We are glad to have had the chance to meet you and learn about your knowledge, experience and skills. We will keep your profile on file and reach out should a more suitable opportunity arise in the future.</p>' +
        '<p>Thank you sincerely!</p>',
    ),
  },
  {
    name: 'Offer email',
    category: 'Recruitment',
    subject: '[Company name] Offer letter for {{candidate_name}} - {{job_title}}',
    body_html: wrapEn(
      '<p>Dear <strong>{{candidate_name}}</strong>,</p>' +
        '<p>Thank you for interviewing with [Company name] for the <strong>{{job_title}}</strong> position.</p>' +
        '<p>Based on our hiring needs, [Company name] is pleased to extend the following offer:</p>' +
        GREEN_BOX +
        '<ul style="margin: 0; padding-left: 20px;">' +
        '<li>Title: <strong>{{job_title}}</strong></li>' +
        '<li>Working hours: [Working hours, working days]</li>' +
        '<li>Work location: [Office address]</li>' +
        '<li>Official salary: <strong>{{salary}}</strong></li>' +
        '<li>Probation salary: [e.g. 85% of official salary, probation duration]</li>' +
        '<li>Expected start date: <strong>{{start_date}}</strong></li>' +
        '</ul></div>' +
        '<p>Please review the offer carefully and reply to this email so HR can proceed with the next steps.</p>' +
        '<p>We look forward to having you join [Company name]!</p>' +
        '<p><em>P/s: When replying, please use REPLY ALL so everyone stays informed.</em></p>',
    ),
  },
  {
    name: 'Onboarding - Welcome new hire',
    category: 'Internal process',
    subject: 'Welcome {{candidate_name}} to [Company name]!',
    body_html: wrapEn(
      '<p>Hi,</p>' +
        '<p>Welcome aboard at [Company name] as <strong>{{job_title}}</strong>.</p>' +
        '<p>I am from HR and will be supporting you through the onboarding process.</p>' +
        '<p>Below is a checklist of items to go through on your first day (<strong>{{start_date}}</strong>):</p>' +
        '<ol>' +
        '<li>Sign probation contract &amp; NDA: HR</li>' +
        '<li>Introduction to the team and your manager: HR</li>' +
        '<li>Set up internal accounts: company email, Portal, Slack/Skype...</li>' +
        '<li>Schedule the company orientation session with HR</li>' +
        '<li>Read the company handbook (attached)</li>' +
        '</ol>' +
        '<p>Feel free to reach out to me anytime if you need anything.</p>' +
        '<p>Once again, welcome — we hope you have a great journey with [Company name]!</p>',
    ),
  },
];

export const DEFAULT_EMAIL_TEMPLATES_BY_LOCALE: Record<
  string,
  readonly DefaultEmailTemplate[]
> = {
  vi: VI_TEMPLATES,
  en: EN_TEMPLATES,
};

export const DEFAULT_EMAIL_TEMPLATES_FALLBACK = EN_TEMPLATES;
